export default __webpack_public_path__ + "assets/3712fd.svg";